import axios from 'axios'

const getCookie = (cname) => {
  const name = `${cname}=`
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      const cookie = c.substring(name.length, c.length)
      if (cookie === '') return false
      return cookie
    }
  }
  return false
}
// 抓cookie裡token的部分放到25,26行

const getConfig = (url, method, data, responseType, token, params = {}) => {
  const config = {
    headers:
      token || getCookie('token')
        ? { Authorization: `Bearer ${token || getCookie('token')}` }
        : {},
    timeout: 600000,
    url: process.env.REACT_APP_AUTH_URL
      ? `${process.env.REACT_APP_AUTH_URL}/${url.replace('api/', '')}`
      : `${window.location.origin}/${url}`,
    method,
    data,
    params,
  }
  if (responseType) config.responseType = responseType
  return config
}
export default {
  login(value) {
    return axios(getConfig('api/auth/login', 'post', value))
      .then((res) => res.data)
      .catch((error) => ({ error }))
  },
  register(value) {
    return axios(getConfig('api/auth/register', 'post', value))
      .then((res) => res.data)
      .catch((error) => ({ error }))
  },
  me() {
    return axios(getConfig('api/me', 'get', {}))
      .then((res) => res.data)
      .catch((error) => ({ error }))
  },
  data(value) {
    return axios(
      getConfig(
        `api/${value.path}`,
        value.method,
        value.data || {},
        value.responseType,
        value.token,
        value.params
      )
    )
      .then((res) => res.data)
      .catch((error) => ({ error }))
  },
  external({ path }) {
    return axios
      .get(path)
      .then((res) => res.data)
      .catch((error) => ({ error }))
  },
}
